import { Injectable, inject } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, from, lastValueFrom, retry } from 'rxjs';
import { fetchAuthSession } from 'aws-amplify/auth';
import { environment } from '@environments/environment';
import { CommonFunctions } from '@app/shared/util/common-functions';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  commonFunction = inject(CommonFunctions);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return from(this.getRefreshToken(request, next)).pipe(
      retry(1)
    );
  }

  async getRefreshToken(req: HttpRequest<any>, next: HttpHandler): Promise<HttpEvent<any>> {
    const headerFlag = !req?.params.get('headerNotRequired');
    let authReq;

    if (headerFlag)
      try {
        const current = environment.authDisable ? environment.authIdToken : (await fetchAuthSession()).tokens?.idToken?.toString() || '';
        authReq = req.clone({
          headers: req.headers
            .set('authorization', current)
            .set('x-api-key', environment.API_KEY)
            .set('x-correlation-id', this.commonFunction.getUUID())
        });
      } catch (error) {
        console.error('Error fetching auth session:', error);
        throw error;
      }
    else
      authReq = req.clone({
        params: req?.params.delete('headerNotRequired')
      });
    return lastValueFrom(next.handle(authReq));
  }
}
